import Swiper from 'swiper';
import { A11y } from 'swiper/modules';
import { makeAllButCurrentSlideInert } from '../utilities/swiperAccessibility';
const $ = window.jQuery;


const $DOM = {};
let cocSwiper;

const domCache = () => {
    $DOM.container = $(".coc-slider");
    if(!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".coc-slider-swiper-container");
    $DOM.txtPagination = $DOM.container.find('.coc-slider-pagination');
    $DOM.txtPaginationLinks = $DOM.txtPagination.find('button[rel]');
}

const initSwiper = () => {
    cocSwiper = new Swiper($DOM.swiperContainer[0], {
        modules: [A11y],
        init: false,
        slidesPerView: 1,
        spaceBetween: 48,
        preventInteractionOnTransition: false,
        speed: 750,
        preventClicksPropagation: false,
        roundLengths: true,
        centeredSlides: true,
        // loop: true,
        a11y: true,
        navigation: false,

        allowTouchMove: false, // preventing the touch slide - only navigate with pagination swiper

        watchOverflow: true,
        breakpoints: {
            768: {
                preventInteractionOnTransition: true,
                spaceBetween: 56
            }
        }
    });

    cocSwiper.on("init", onInit);
    cocSwiper.on("activeIndexChange", onActiveIndexChange);
    cocSwiper.init();
}


const onInit = (swiperInstance) => {
    $DOM.swiperContainer.addClass("is-init");
    setTxtPaginationActiveItem(0);

    makeAllButCurrentSlideInert(swiperInstance);

}

const onActiveIndexChange = (swiperInstance) => {
    setTxtPaginationActiveItem(swiperInstance.realIndex);
    makeAllButCurrentSlideInert(swiperInstance);
}

const handleTxtPagination = () => {
    $DOM.txtPaginationLinks.on("click", function () {
        const slideIndex = parseInt($(this).attr("rel"));
        cocSwiper.slideTo(slideIndex);
    });
}

const setTxtPaginationActiveItem = (slideIndex) => {
    $DOM.txtPaginationLinks.not("[rel="+slideIndex+"]").removeClass("is-active");
    $DOM.txtPaginationLinks.filter("[rel="+slideIndex+"]").addClass("is-active");
}



const cocSlider = {
    init: () => {
        domCache();
        if(!$DOM.container.length) {
            return;
        }
        initSwiper();
        handleTxtPagination();
    }
};

export default cocSlider;
